import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, A11y, Autoplay, EffectFade } from 'swiper';
import { Link, useHistory } from 'react-router-dom';

import api from '../../services/api';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { useForm } from '../../hooks/useForm';
import { logout } from '../../services/auth';

import ImageSlide1 from '../../assets/register-slide-1.jpg';
import ImageSlide2 from '../../assets/register-slide-2.jpg';
import ImageSlide3 from '../../assets/register-slide-3.jpg';
import ImageSlide4 from '../../assets/register-slide-4.jpg';
import ImageSlide5 from '../../assets/register-slide-5.jpg';
import ImageLogoNooio from '../../assets/logo-nooio-black.svg';

import { RegisterContainer } from './styles';
import 'swiper/swiper-bundle.min.css';

SwiperCore.use([Navigation, Pagination, EffectFade, A11y, Autoplay]);

interface RegisterData {
  name: string;
  phone: string;
  email: string; 
  cpf: string; 
  password: string; 
  password2: string; 
}

function Register() {
  const history = useHistory();
  const { getEntriesByEvent } = useForm();

  async function handleRegister(e: React.FormEvent) {
    e.preventDefault();

    const entries = getEntriesByEvent<RegisterData>(e);
    if (!entries) return;

    const {
      name,
      phone,
      email, 
      cpf, 
      password, 
      password2, 
    } = entries;

    if (password !== password2) handleMessage(100, 'Erro', 'Opa, parece que as senhas que você digitou não são iguais');
    setTimeout(() => { 
      if (password.length < 8 || password2.length < 8) handleMessage(101, 'Erro', 'Sua senha é muito curta, o minimo é de 8 caracteres.');
    }, 500);
    if (password !== password2 || password.length < 8) return;

    const { result } = await api.post(
      '/auth/register', 
      {
        name, 
        contact_phone: phone.replace('(', '').replace(')', '').replace(' ', '').replace('-', ''), 
        email, 
        cpf: cpf.replace('.', '').replace('.', '').replace('-', ''), 
        password, 
      }
    )
      .then(response => response && response.data)
      .catch(() => handleMessage(103, 'Erro', 'Houve um erro inesperado, verifique os dados e tente novamente'))
    ;

    if (!result) return;

    handleMessage(200, 'Sucesso', 'Uhuu, sua conta foi criada com sucesso.');
    logout({ redirect: false });

    setTimeout(() => {
      history.push(`/verify-account?user_id=${result.user_id}`);
    }, 1500);
  }

  function handleMessage(code: number, title: string, error: string) {
    const messages = document.querySelector('.messages-container');
    const message = document.createElement('div');

    // Verify if message already exist
    const messagesList = Array.from(document.querySelectorAll('.status-message'));
    const alreadyExist = messagesList.find(messageItem => messageItem.id === `code-${code}`);
    if (alreadyExist) return;

    message.className = 'status-message';
    message.classList.add(code === 200 ? 'success' : 'error');
    message.id = 'code-' + code;
    message.innerHTML = `
      <i class="fal fa-times"></i>

      <div class="text">
        <strong>${title}</strong>
        <span>${error}</span>
      </div>
    `;
    message.style.animation = 'enterAnimation .5s ease-in-out forwards';

    messages?.appendChild(message);
    document.querySelector(`#code-${code} i`)?.addEventListener('click', remove);

    function remove() {
      message.style.animation = 'outAnimation .5s ease-in-out forwards';

      setTimeout(() => {
        message.remove();
      }, 500);
    }

    setTimeout(remove, 10000);
  }

  function handleBack() {
    history.goBack();
  }

  return (
    <RegisterContainer>
      <header>
        <span onClick={handleBack}>
          <i className="far fa-arrow-left"></i>
          <span>Voltar</span>
        </span>

        <Link to="/login">Entrar</Link>
      </header>

      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        effect="fade"
        navigation
        loop
        pagination={{ clickable: true }}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
      >
        
        <SwiperSlide>
          <img src={ImageSlide2} alt="slide 2" />
          <div className="shadow"></div>
        </SwiperSlide>

        <SwiperSlide>
          <img src={ImageSlide1} alt="slide 1" />
          <div className="shadow"></div>
        </SwiperSlide>
        
        <SwiperSlide>
          <img src={ImageSlide3} alt="slide 3" />
          <div className="shadow"></div>
        </SwiperSlide>

        <SwiperSlide>
          <img src={ImageSlide4} alt="slide 4" />
          <div className="shadow"></div>
        </SwiperSlide>

        <SwiperSlide>
          <img src={ImageSlide5} alt="slide 5" />
          <div className="shadow"></div>
        </SwiperSlide>

      </Swiper>

      <div className="register-content">
        <div className="form-container">
          <div className="heading">
            <img src={ImageLogoNooio} alt="Nooio" />
            <h1>Cadastre-se</h1>
          </div>

          <form id="register-form" onSubmit={handleRegister}>
            <Input 
              name="name" 
              label="Nome"  
            />

            <Input 
              name="phone" 
              mask="(##) #####-####" 
              label="Telefone" 
              isNumber 
            />
            
            <Input 
              name="email" 
              label="E-mail" 
            />
            
            <Input 
              name="cpf" 
              mask="###.###.###-##" 
              label="CPF" 
            />

            <div className="group-input">
              <Input 
                type="password" 
                name="password" 
                label="Senha" 
              />

              <Input 
                type="password" 
                name="password2" 
                label="Confirme a senha" 
              />
            </div>

            <Button type="submit" >Cadastrar-se</Button>
          </form>

          <div className="has-account">
            <div className="or"></div>

            <Link to="/login">Já tem conta? <strong>Entrar</strong></Link>
          </div>
        </div>
      </div>

      <div className="messages-container"></div>
    </RegisterContainer>
  );
};

export default Register;
